export const SAVE = 'SAVE';
export const GENERATE_AS_COPY = 'GENERATE_AS_COPY';
